import { SemafoneRequestParams } from '@ucx-js/chat-ui';
import { getBrand } from './getBrand';
import { appConfig } from '../init/getAppConfig';
import { EnvType } from '../app/types/enum';

export function getSemafoneConfig(): SemafoneRequestParams {
  const semafoneConfig = {
    qa: {
      rogers: {
        semafoneLicCode: 'mnEpzJwHTQ',
        semafonePassword: 'aFNBMwQ2xZeyxPPpeAYA',
        semafoneHost: 'https://htsdev02.rogers.com',
        accountId: '464',
        userId: 'vaas000169',
        principle: 'rdl',
      },
      fido: {
        semafoneLicCode: 'mnEpzJwHTQ',
        semafoneHost: 'https://htsdev02.rogers.com',
        semafonePassword: 'aFNBMwQ2xZeyxPPpeAYA',
        accountId: '464',
        userId: 'vaas000169',
        principle: 'rdl',
      },
    },
    prod: {
      rogers: {
        semafoneLicCode: 'UzYRN49OYT',
        semafonePassword: 'TcT2sUbtllPZC6TtOdLA',
        semafoneHost: 'https://hts.rogers.com',
        accountId: '533',
        userId: 'vaas000221',
        principle: 'rcompay',
      },
      fido: {
        semafoneLicCode: 'aV2FcqS0Jv',
        semafonePassword: '4zrrJiQSCeG3TI9KeheX',
        semafoneHost: 'https://hts.rogers.com',
        accountId: '541',
        userId: 'vaas000191',
        principle: 'fidop',
      },
    },
  };

  if (
    appConfig.envType == EnvType.prod ||
    appConfig.envType == EnvType.staging
  ) {
    return semafoneConfig.prod[getBrand().name];
  } else {
    return semafoneConfig.qa[getBrand().name];
  }
}
